import { useState } from 'react'
import {
  Button,
  Carousel,
  CarouselControl,
  CarouselIndicators,
  CarouselItem,
  Modal,
  ModalBody,
  Spinner,
} from 'reactstrap'

const PMBModalImagePreview = ({
  isOpen,
  toggle,
  images = [],
  startIndex = 0,
  isDownload = false,
  isModal = true,
  onClick,
  testId = 'pmb-image-preview',
}) => {
  const [activeIndex, setActiveIndex] = useState(startIndex)
  const [animating, setAnimating] = useState(false)
  const [isDownloadPdf, setIsDownloadPdf] = useState(false)

  const safeImages = Array.isArray(images) ? images : []

  const next = () => {
    if (animating || safeImages.length <= 1) return
    const nextIndex =
      activeIndex === safeImages.length - 1 ? 0 : activeIndex + 1
    setActiveIndex(nextIndex)
  }

  const previous = () => {
    if (animating || safeImages.length <= 1) return
    const nextIndex =
      activeIndex === 0 ? safeImages.length - 1 : activeIndex - 1
    setActiveIndex(nextIndex)
  }

  const goToIndex = (newIndex) => {
    if (animating || safeImages.length <= 1) return
    setActiveIndex(newIndex)
  }

  const slides = safeImages.map((url, index) => {
    const isPdf = url?.toLowerCase()?.endsWith('.pdf')

    return (
      <CarouselItem
        key={index}
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
      >
        {isModal ? (
          isPdf ? (
            <div
              onClick={() => window.open(url, '_blank')}
              style={{
                width: '100%',
                height: '300px',
                border: '1px dashed #888',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                background: '#f8f9fa',
              }}
            >
              <span className="fw-semibold">
                📄 Lampiran PDF — klik untuk lihat
              </span>
            </div>
          ) : (
            <img
              src={url}
              style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
              alt={`carousel-item-${index}`}
            />
          )
        ) : (
          <div
            onClick={() => {
              if (isPdf) {
                window.open(url, '_blank')
              } else {
                onClick?.(index)
              }
            }}
            style={{ cursor: 'pointer' }}
          >
            {isPdf ? (
              <div
                style={{
                  width: '100%',
                  height: '150px',
                  border: '1px dashed #888',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: '#f8f9fa',
                }}
              >
                📄 Lihat PDF
              </div>
            ) : (
              <img
                src={url}
                style={{ width: '100%', height: '150px', objectFit: 'cover' }}
                alt={`carousel-item-${index}`}
              />
            )}
          </div>
        )}
      </CarouselItem>
    )
  })

  const handleDownload = async () => {
    if (isDownloadPdf) return
    setIsDownloadPdf(true)

    const currentUrl = images[activeIndex]
    const isPdf = currentUrl?.toLowerCase()?.endsWith('.pdf')

    try {
      const fileExt = isPdf ? 'pdf' : 'jpg'
      const fileName = `document-${activeIndex + 1}.${fileExt}`

      const response = await fetch(currentUrl, { mode: 'cors' })
      if (!response.ok) throw new Error('Gagal mengambil file')

      const blob = await response.blob()
      const blobUrl = URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = blobUrl
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      URL.revokeObjectURL(blobUrl)
    } catch (error) {
      console.error('Download gagal:', error)

      if (isPdf) window.open(currentUrl, '_blank')
    }

    setIsDownloadPdf(false)
  }

  if (isModal) {
    return (
      <Modal
        className="p-4"
        centered
        isOpen={isOpen}
        toggle={toggle}
        autoFocus={false}
        size="md"
        data-testid={testId}
      >
        <ModalBody>
          {safeImages.length > 0 ? (
            <Carousel
              activeIndex={activeIndex}
              next={next}
              previous={previous}
              interval={false}
            >
              {safeImages.length > 1 && (
                <>
                  <CarouselIndicators
                    items={safeImages}
                    activeIndex={activeIndex}
                    onClickHandler={goToIndex}
                  />
                  <CarouselControl
                    direction="prev"
                    directionText="Previous"
                    onClickHandler={previous}
                    data-testid={`${testId}-prev`}
                  />
                  <CarouselControl
                    direction="next"
                    directionText="Next"
                    onClickHandler={next}
                    data-testid={`${testId}-next`}
                  />
                </>
              )}
              {slides}
            </Carousel>
          ) : (
            <p>No images to display</p>
          )}
        </ModalBody>

        <div className="d-flex pb-3 px-3 justify-content-end">
          {safeImages.length > 0 && isDownload && (
            <div className="d-flex gap-2">
              <Button
                disabled={isDownloadPdf}
                className="btn-cancel"
                size="sm"
                outline
                data-testid={`${testId}-close`}
                onClick={() => {
                  toggle()
                }}
              >
                Tutup
              </Button>
              <Button
                disabled={isDownloadPdf}
                className="d-flex align-items-center"
                color="primary"
                size="sm"
                data-testid={`${testId}-download`}
                onClick={handleDownload}
              >
                {isDownloadPdf && (
                  <Spinner
                    className="me-1"
                    size="sm"
                    style={{ color: '#fff' }}
                  />
                )}
                Unduh
              </Button>
            </div>
          )}
        </div>
      </Modal>
    )
  } else {
    return (
      <>
        {safeImages.length > 0 ? (
          <Carousel
            activeIndex={activeIndex}
            next={next}
            previous={previous}
            interval={false}
          >
            {safeImages.length > 1 && (
              <>
                <CarouselIndicators
                  items={safeImages}
                  activeIndex={activeIndex}
                  onClickHandler={goToIndex}
                />
                <CarouselControl
                  direction="prev"
                  directionText="Previous"
                  onClickHandler={previous}
                  data-testid={`${testId}-prev`}
                />
                <CarouselControl
                  direction="next"
                  directionText="Next"
                  onClickHandler={next}
                  data-testid={`${testId}-next`}
                />
              </>
            )}
            {slides}
          </Carousel>
        ) : (
          <p>No images to display</p>
        )}

        <div className="d-flex pb-3 px-3 justify-content-end">
          {safeImages.length > 0 && isDownload && (
            <div className="d-flex gap-2">
              <Button
                disabled={isDownloadPdf}
                className="btn-cancel"
                size="sm"
                outline
                data-testid={`${testId}-close`}
                onClick={() => {
                  toggle()
                }}
              >
                Tutup
              </Button>
              <Button
                disabled={isDownloadPdf}
                className="d-flex align-items-center"
                color="primary"
                size="sm"
                data-testid={`${testId}-download`}
                onClick={handleDownload}
              >
                {isDownloadPdf && (
                  <Spinner
                    className="me-1"
                    size="sm"
                    style={{ color: '#fff' }}
                  />
                )}
                Unduh Gambar
              </Button>
            </div>
          )}
        </div>
      </>
    )
  }
}

export default PMBModalImagePreview
